module.exports = __webpack_public_path__ + "statics/img/Invitation-approval-failed-logo.6a1d7815.png";